const activityTypeGroups = [
  {
    label: '活動',
    options: [
      { value: 'general_lecture', label: '一般講座/工作坊' },
      { value: 'eap_lecture', label: 'EAP講座' },
      { value: 'investigation_committee', label: '調查委員會議' },
      { value: 'support_group', label: '安心團體' },
      { value: 'worry_free_lecture', label: '無憂講座' },
    ],
  },
  {
    label: '文件',
    options: [
      { value: 'attendance_certificate', label: '出席證明' },
      { value: 'counseling_record', label: '諮商紀錄/摘要' },
      { value: 'psychological_assessment', label: '心理評估報告' },
    ],
  },
  {
    label: '蛹之生內部',
    options: [
      { value: 'education_training', label: '教育訓練' },
      { value: 'intern_activity', label: '實習生活動' },
      { value: 'group_supervision', label: '團督' },
      { value: 'internal_borrow', label: '內部成員借用' },
    ],
  },
];

export function getActivityTypeGroups() {
  return JSON.parse(JSON.stringify(activityTypeGroups));
}

export default { getActivityTypeGroups };
